<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <b-container fluid>
      <br />
      <b-tabs class="mt-3" v-model="tab_index">
        <b-tab
          :title="`${$getVisibleNames(
            'mesh.egressprofilematter',
            true,
            'Asignaturas'
          )}`"
        >
          <MatterList class="mt-4" :allows_crud="allows_crud"> </MatterList>
        </b-tab>
        <b-tab
          :title="$getVisibleNames('teaching.matter', true, 'Asignaturas Base')"
        >
          <template v-if="load_old_matter">
            <OldMatterAltList class="mt-4" :allows_crud="allows_crud">
            </OldMatterAltList>
          </template>
        </b-tab>
        <b-tab
          v-if="
            institution &&
            institution.internal_use_id == 'duoc.cl' &&
            ([
              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
              'DIRECTIVOS ACADÉMICOS (CAMPUS)',
            ].some((group) => user.group_names.includes(group)) ||
              user.is_superuser)
          "
          :title="
            $getVisibleNames(
              'teaching.duocsapmatter',
              true,
              'Asignaturas creadas en SAP'
            )
          "
        >
          <DuocSapMatterList class="mt-4" :allows_crud="allows_crud">
          </DuocSapMatterList>
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  name: "MatterListView",
  components: {
    OldMatterAltList: () =>
      import("@/components/mesh/CurricularResources/Matter/OldMatterAltList"),
    DuocSapMatterList: () =>
      import(
        "@/components/teaching/CurricularResources/DuocSapMatter/DuocSapMatterList"
      ),
    MatterList: () =>
      import("@/components/mesh/CurricularResources/Matter/MatterList"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    display_id: {},
  },
  data() {
    return {
      tab_index: 0,
      load_old_matter: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.egressprofilematter",
            true,
            "Asignaturas"
          ),
        },
      ];
    },
    allows_crud() {
      if (this.user && this.user.is_superuser) {
        const has_permission = this.$hasPermissions(
          "mesh.add_egressprofilematter"
        );
        if (has_permission) {
          this.$store.commit(names.MUTATE_VISIBILITY_CRUD, true);
          return has_permission;
        } else return false;
      } else {
        this.$store.commit(names.MUTATE_VISIBILITY_CRUD, false);
        return false;
      }
    },
  },
  methods: {},
  mounted() {},
  created() {
    this.$store.dispatch(names.FETCH_TIME_ALLOCATIONS);
    this.$store.dispatch(names.FETCH_FORMATION_AREAS);
    this.$store.dispatch(names.FETCH_MATTER_TYPES);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS);
    this.$store.dispatch(names.FETCH_MATTER_CONTRIBUTIONS);
    this.$store.dispatch(names.FETCH_FORMATION_LINES);
    this.$store.dispatch(names.FETCH_REGIMES);
    this.$store.dispatch(names.FETCH_MODALITIES);
  },
  watch: {
    tab_index: function () {
      if (this.tab_index == 1) {
        this.load_old_matter = true;
      }
    },
  },
};
</script>
<style scoped>
.table-title {
  font-size: var(--primary-font-size);
}
.b-card-style {
  background: var(--primary-color);
}
.th-style {
  background: var(--secondary-color) !important;
  color: var(--secondary-font-color);
}

.modal th {
  background-color: var(--primary-color);
  color: var(--primary-font-color);
  font-weight: normal;
}
p {
  text-align: justify;
  margin-left: 2px;
  padding-left: 12px;
  margin-right: 2px;
  padding-right: 12px;
  font-size: var(--secondary-font-size);
}
td[colspan="5"] {
  max-width: 35rem;
}
td {
  vertical-align: middle;
  text-align: center;
}

.campus-div {
  background-color: var(--secondary-color);
  color: white;
  width: auto;
  border-radius: 3px;
  margin: 0.1em 0.1em;
  padding: 1px 4px;
  flex-grow: 1;
  font-size: var(--thirth-font-size);
  text-align: center;
}
.campus-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>